// Import api models.
import {
	PossibleBusinessType,
	PossibleHeardThroughOption,
	PossibleMasterProducer,
} from '@app/models/api';

interface ProducerSignupState {
	areHeardThroughOptionsLoaded: boolean;
	arePossibleBusinessTypesLoaded: boolean;
	arePossibleMasterProducersLoaded: boolean;
	heardThroughOptions: PossibleHeardThroughOption[];
	possibleBusinessTypes: PossibleBusinessType[],
	possibleMasterProducers: PossibleMasterProducer[],
};


const getInitialState = (): ProducerSignupState => {
	return {
		areHeardThroughOptionsLoaded: false,
		arePossibleBusinessTypesLoaded: false,
		arePossibleMasterProducersLoaded: false,
		heardThroughOptions: [],
		possibleBusinessTypes: [],
		possibleMasterProducers: [],
	};
};

export { getInitialState, ProducerSignupState };